import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import '../brand-theme.css';
const {FiMenu,FiMusic,FiPhone,FiX}=FiIcons;
function AppHeader({mode,setMode,menuOpen,setMenuOpen,settings,clientPreview=false}) {
  return (
    <header className="topbar">
      <button type="button" className="mobile-menu" onClick={()=> setMenuOpen(!menuOpen)} aria-label="Toggle menu">
        <SafeIcon icon={menuOpen ? FiX : FiMenu} />
      </button>
      <div className="brand">
        <span className="brand-mark">
          {settings.logo ? <img src={settings.logo} alt="" /> : <SafeIcon icon={FiMusic} />}
        </span>
        <span>
          <strong>{settings.appName}</strong>
          <small>EVENT BACKSTAGE</small>
        </span>
      </div>
      <div className="header-actions">
        <a className="phone-link" href={`tel:${settings.phone.replace(/\D/g,'')}`}>
          <SafeIcon icon={FiPhone} /> {settings.phone}
        </a>
        {mode==='admin' && (
          <div className="mode-switch">
            <button type="button" className="active" onClick={()=> setMode('admin')}>Admin</button>
            <button type="button" onClick={()=> setMode('client')}>Client preview</button>
          </div>
        )}
        {clientPreview && (
          <div className="mode-switch">
            <button type="button" className="active" onClick={()=> setMode('admin')}>Return to admin</button>
          </div>
        )}
      </div>
    </header>
  );
}
export default AppHeader;